import Link from "next/link";
import React from "react";

function CollatsBrief() {
  return (
    <div className="flex justify-center text-gray-600 body-font">
      <div className="max-w-7xl  ">
        <div className="container mx-auto flex px-5 pt-32 md:flex-row flex-col items-center">
          <div className="flex md:hidden w-4/6 mb-20">
            <img
              className="object-cover object-center rounded"
              alt="hero"
              src="/images/backup_tokens.svg"
            ></img>
          </div>
          <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
            <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
              More than just a token
            </h1>
            <p className="mb-4 leading-relaxed">
              Collats provide the means to add a collateralized value to crypto
              assets. Each Collats token is backed one-to-one by a US Dollar
              pegged stable coin.
            </p>
            <p className="mb-4 leading-relaxed">
              {
                "Collats are immune to the swings or fluctuations of the Crypto Currency market. When they get minted the same amount of an accepted Stable Coin is locked in vault. The decentralized nature of Collats does not allow to speculate with any percentage of the backup assets tied to the Collats' total supply."
              }
            </p>
            <p className="mb-4 leading-relaxed">
              There are many use cases for Collats. For example collateralized
              NFTs can be hypothecated, lent or insured and their Collats value
              can be redeemed anytime one-to-one by USD pegged Stable Coins.
            </p>
            {/* <div className="flex justify-center">
            <button className="inline-flex text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg">
              Button
            </button>
            <button className="ml-4 inline-flex text-gray-700 bg-gray-100 border-0 py-2 px-6 focus:outline-none hover:bg-gray-200 rounded text-lg">
              Button
            </button>
          </div> */}

            <div className="flex flex-wrap justify-center">
              <Link href="/swap">
                <a className="block px-12 py-3 text-sm font-medium text-white bg-blue-600 border border-blue-600 rounded sm:w-auto active:text-opacity-75 hover:bg-transparent hover:text-blue-600 focus:outline-none focus:ring">
                  Mint Collats
                </a>
              </Link>
            </div>
          </div>
          <div className="hidden md:flex lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
            <img
              className="object-cover object-center rounded"
              alt="hero"
              src="/images/backup_tokens.svg"
            ></img>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CollatsBrief;
